import React from 'react'
import { SwiperSlide } from 'swiper/react'
import { TonalitaDetailObject } from '@gql/graphql'
import { GalleryModal } from '@components/organisms'
import styles from './TonalitaSectionGalleryModal.module.sass'
import { WImage } from '@components/atoms'

interface Props {
  id: string
  tonalita: TonalitaDetailObject
  initialSlide?: number
  open?: boolean
  onClose?: () => void
  className?: string
}

const TonalitaSectionGalleryModal = (props: Props) => {
  const {
    id = undefined,
    tonalita = undefined,
    initialSlide = 0,
    open = false,
    onClose = undefined,
    className = '',
  } = props

  return tonalita?.tonalitaCollezione?.gallery?.length ? (
    <GalleryModal
      id={id}
      items={tonalita?.tonalitaCollezione?.gallery.map((x) => ({
        pk: x.id,
        image: x.url,
        alt: x.altTag,
      }))}
      zoom
      paginationStyle="thumbs"
      initialSlide={initialSlide}
      open={open}
      onClose={onClose}
      className={`${styles.root} ${className}`}
      mainSwiperClassName={styles.mainSwiper}
    >
      {tonalita?.tonalitaCollezione?.gallery.map((x) => (
        <SwiperSlide key={x.id}>
          <div className={`${styles.imageBox} swiper-zoom-wrapper`}>
            <div className={`swiper-zoom-container`}>
              <WImage
                src={x.url}
                alt={x?.imageAlt}
                maxWidth={1240}
                maxHeight={560}
                className={styles.image}
              />
            </div>
          </div>
        </SwiperSlide>
      ))}
    </GalleryModal>
  ) : (
    <></>
  )
}

export default TonalitaSectionGalleryModal
